import { PublicActionButton } from "@/shared/public-ui";
import { authPageContent, type AuthSubmitLabel } from "./content";

type AuthButtonType =
  | AuthSubmitLabel
  | "Sign up"
  | "Reset Password"
  | "Forgot Password";

export default function AuthButton({
  type,
  loading,
}: {
  type: AuthButtonType;
  loading: boolean;
}) {
  return (
    <PublicActionButton
      type="submit"
      loading={loading}
      loadingText={authPageContent.forms.loadingText}
      disabled={loading}
      width="full"
      px="12"
      py="3"
      _disabled={{ opacity: 0.7, cursor: "not-allowed" }}
    >
      {type}
    </PublicActionButton>
  );
}
